// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/farsi.TTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
@font-face {
    font-family: "farsi";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }
body {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f4;
    margin: 0;
    font-family: Arial, sans-serif;
    padding-top: 20px;
  }
  [dir="rtl"] body,div,input,button {
    font-family: "farsi", sans-serif !important; /* Font for Farsi */
  }
  
  .logo {
    margin-bottom: 20px;
  }
  
  .container {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: left;
    width: 90%;
    max-width: 1200px;
    min-width: 1000px;
  }
  
  .tabs {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  
  .tab {
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .tab:hover {
    background: #0056b3;
  }
  
  .tab.active {
    background: #0056b3;
  }
  
  .content {
    display: none;
  }
  
  .content.active {
    display: block;
  }
  
  .app-list,
  .deploy-logs,
  .panels-table,
  .billing-section,
  .profile-section {
    margin-top: 20px;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  th,
  td {
    padding: 10px;
    border: 1px solid #ddd;
  }
  
  th {
    background-color: #f4f4f4;
  }
  
  button {
    padding: 5px 10px;
    margin: 2px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }
  
  button.run {
    background-color: #28a745;
    color: white;
  }
  
  button.stop {
    background-color: #ffc107;
    color: black;
  }
  
  button.delete {
    background-color: #dc3545;
    color: white;
  }
  
  button.domain {
    background-color: #17a2b8;
    color: white;
  }
  
  button.details {
    background-color: #6c757d;
    color: white;
  }
  
  .modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    width: 300px;
    text-align: center;
  }
  
  .modal-content input {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  
  .modal-content button {
    margin: 5px;
  }
  
  .language-toggle {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
  
  [dir="rtl"] .language-toggle {
    right: auto;
    left: 20px;
  }
  
  [dir="rtl"] {
    text-align: right;
  }
  
  [dir="rtl"] .container {
    text-align: right;
  }
  
  [dir="rtl"] .modal-content {
    text-align: right;
  }
  
  [dir="rtl"] table th,
  [dir="rtl"] table td {
    text-align: right;
  }
  
  [dir="rtl"] .form-container input {
    text-align: right;
  }
  
  @media (max-width: 768px) {
    .tabs {
      flex-direction: column;
    }
  
    .tab {
      width: 100%;
      margin-bottom: 10px;
    }
  
    .container {
      padding: 10px;
    }
  }
  .login-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  
  .login-container form {
    display: flex;
    flex-direction: column;
    width: 300px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .login-container label {
    margin-bottom: 5px;
    font-weight: bold;
  }
  
  .login-container input {
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box; /* Ensure padding doesn't affect width */
  }
  
  .login-container button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .logout-button {
    position: absolute;
    top: 20px;
    right: 100px;
    padding: 10px;
    background-color: #dc3545;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  .login-container button:hover {
    background-color: #0056b3;
  }
  
  .register-link {
    margin-top: 10px;
    text-align: center;
  }
  
  .register-link a {
    color: #007bff;
    text-decoration: none;
  }
  
  .register-link a:hover {
    text-decoration: underline;
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,oBAAoB;IACpB,+DAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;EACpB;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,2CAA2C,EAAE,mBAAmB;EAClE;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;;;;IAKE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB,EAAE,wCAAwC;EAClE;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B","sourcesContent":["/* App.css */\n@font-face {\n    font-family: \"farsi\";\n    src: url(\"fonts/farsi.TTF\") format(\"truetype\");\n    font-weight: normal;\n    font-style: normal;\n  }\nbody {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100vh;\n    background-color: #f4f4f4;\n    margin: 0;\n    font-family: Arial, sans-serif;\n    padding-top: 20px;\n  }\n  [dir=\"rtl\"] body,div,input,button {\n    font-family: \"farsi\", sans-serif !important; /* Font for Farsi */\n  }\n  \n  .logo {\n    margin-bottom: 20px;\n  }\n  \n  .container {\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    text-align: left;\n    width: 90%;\n    max-width: 1200px;\n    min-width: 1000px;\n  }\n  \n  .tabs {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n  }\n  \n  .tab {\n    padding: 10px 20px;\n    background: #007bff;\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: 0.3s;\n  }\n  \n  .tab:hover {\n    background: #0056b3;\n  }\n  \n  .tab.active {\n    background: #0056b3;\n  }\n  \n  .content {\n    display: none;\n  }\n  \n  .content.active {\n    display: block;\n  }\n  \n  .app-list,\n  .deploy-logs,\n  .panels-table,\n  .billing-section,\n  .profile-section {\n    margin-top: 20px;\n  }\n  \n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n  }\n  \n  th,\n  td {\n    padding: 10px;\n    border: 1px solid #ddd;\n  }\n  \n  th {\n    background-color: #f4f4f4;\n  }\n  \n  button {\n    padding: 5px 10px;\n    margin: 2px;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n  }\n  \n  button.run {\n    background-color: #28a745;\n    color: white;\n  }\n  \n  button.stop {\n    background-color: #ffc107;\n    color: black;\n  }\n  \n  button.delete {\n    background-color: #dc3545;\n    color: white;\n  }\n  \n  button.domain {\n    background-color: #17a2b8;\n    color: white;\n  }\n  \n  button.details {\n    background-color: #6c757d;\n    color: white;\n  }\n  \n  .modal {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .modal-content {\n    background: white;\n    padding: 20px;\n    border-radius: 10px;\n    width: 300px;\n    text-align: center;\n  }\n  \n  .modal-content input {\n    width: 100%;\n    padding: 8px;\n    margin-bottom: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n  }\n  \n  .modal-content button {\n    margin: 5px;\n  }\n  \n  .language-toggle {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    padding: 10px 20px;\n    background: #007bff;\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  [dir=\"rtl\"] .language-toggle {\n    right: auto;\n    left: 20px;\n  }\n  \n  [dir=\"rtl\"] {\n    text-align: right;\n  }\n  \n  [dir=\"rtl\"] .container {\n    text-align: right;\n  }\n  \n  [dir=\"rtl\"] .modal-content {\n    text-align: right;\n  }\n  \n  [dir=\"rtl\"] table th,\n  [dir=\"rtl\"] table td {\n    text-align: right;\n  }\n  \n  [dir=\"rtl\"] .form-container input {\n    text-align: right;\n  }\n  \n  @media (max-width: 768px) {\n    .tabs {\n      flex-direction: column;\n    }\n  \n    .tab {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n  \n    .container {\n      padding: 10px;\n    }\n  }\n  .login-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n  }\n  \n  .login-container form {\n    display: flex;\n    flex-direction: column;\n    width: 300px;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .login-container label {\n    margin-bottom: 5px;\n    font-weight: bold;\n  }\n  \n  .login-container input {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box; /* Ensure padding doesn't affect width */\n  }\n  \n  .login-container button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n  }\n  \n  .logout-button {\n    position: absolute;\n    top: 20px;\n    right: 100px;\n    padding: 10px;\n    background-color: #dc3545;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  .login-container button:hover {\n    background-color: #0056b3;\n  }\n  \n  .register-link {\n    margin-top: 10px;\n    text-align: center;\n  }\n  \n  .register-link a {\n    color: #007bff;\n    text-decoration: none;\n  }\n  \n  .register-link a:hover {\n    text-decoration: underline;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
